import { render, staticRenderFns } from "./imagePreview.vue?vue&type=template&id=63198380&scoped=true&"
import script from "./imagePreview.vue?vue&type=script&lang=js&"
export * from "./imagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63198380",
  null
  
)

export default component.exports